import Vue from 'vue';
import VueRouter from 'vue-router';
import ActivityForm from './components/ActivityForm';
import DeleteActivityConfirmation from './components/DeleteActivityConfirmation';
import FacilityUsageForm from './components/FacilityUsageForm';
import InitialForm from './components/InitialForm';
import ZeroUsageConfirmation from './components/ZeroUsageConfirmation';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }

    try {
        return originalPush.call(this, location).catch(err => err);
    } catch (error) {
        console.log(error);
    }
};

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            path: '/',
            component: InitialForm,
            name: 'initial-form'
        },
        {
            path: '/:permitNumber/:permitYear',
            component: ActivityForm,
            name: 'activity-form'
        },
        {
            path: '/:permitNumber/:permitYear/add-activity',
            component: FacilityUsageForm,
            name: 'add-activity',
            props: { isCreate: true }
        },
        {
            path: '/:permitNumber/:permitYear/edit-activity/:index',
            component: FacilityUsageForm,
            name: 'edit-activity',
            props: (route) => ({ isCreate: false, index: route.params.index })
        },
        {
            path: '/:permitNumber/:permitYear/delete-activity/:index',
            component: DeleteActivityConfirmation,
            name: 'delete-activity',
            props: (route) => ({ index: route.params.index })
        },
        {
            path: '/:permitNumber/:permitYear/no-usage-confirmation',
            component: ZeroUsageConfirmation,
            name: 'zero-usage-confirmation'
        }
    ]
});